import "react-tooltip/dist/react-tooltip.css";
import React from "react";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
export const Roles = {
  Super_Admin: 1,
  Admin: 2,
  User: 3,
};

export const DealTypes = {
  Residential: 1,
  Commercial: 2,
  "All Deal Types": 3,
  "ID Verification": 4,
  "Tax Verification": 6,
};

export const monthDigits = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

export const PasswordRegex = {
  isNumberRegx: /\d/,
  specialCharacterRegx: /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, //eslint-disable-line
  upperCaseRegx: /[A-Z]/,
  LowerCaseRegx: /[a-z]/,
  websiteNameRegex: /^((?!ctic|FNF|chicagotitle).)*$/i,
};

export const RegistrationRegex = {
  isValidCode: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
};

export const EmailRegex = {
  isEmailRegx: /^([A-Za-z0-9_\.-]+)@([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,5})$/,
};
export const TextBoxErrorMsgCss = {
  placeholderColor: "#E2211C",
  placeHolderFontWeight: "600",
  placeHolderFontSize: "16px",
  placeHolderFontOpacity: 1,
  borderCss: "1px solid #E2211C",
};

function generateArrayOfYears() {
  var max = new Date().getFullYear();
  var min = 1950;
  var years = [];
  // years.push({ label: "Select Years", value: "0" },)
  for (var i = max; i >= min; i--) {
    var yearlst = { value: i, label: i };
    years.push(yearlst);
  }
  return [{ value: undefined, label: "litSelect" }, ...years];
}

export const RegistrationPageConstants = {
  YearsOptions: generateArrayOfYears(),
  MothOptions: [
    {value: undefined, label: "litSelect"},
    { value: "01", label: "litJan" },
    { value: "02", label: "litFeb" },
    { value: "03", label: "litMar" },
    { value: "04", label: "litApr" },
    { value: "05", label: "litMay" },
    { value: "06", label: "litJun" },
    { value: "07", label: "litJul" },
    { value: "08", label: "litAug" },
    { value: "09", label: "litSep" },
    { value: "10", label: "litOct" },
    { value: "11", label: "litNov" },
    { value: "12", label: "litDec" },
  ],
  ResiTransactionPerMonth: [
    { value: "Zero", label: "0" },
    { value: "Between 1-10", label: "1-10" },
    { value: "Between 11-30", label: "11-30" },
    { value: "Between 31-50", label: "31-50" },
    { value: "Between 51-75", label: "51-75" },
    { value: "greater than 76", label: "76+" },
  ],
  CommTransactionPerMonth: [
    { value: "Zero", label: "0" },
    { value: "Between 1-5", label: "1-5" },
    { value: "Between 6-15", label: "6-15" },
    { value: "Between 16-25", label: "16-25" },
    { value: "greater than 26", label: "26+" },
  ],
  percentage: [
    { value: "less than 25%", label: "<25%" },
    { value: "Between 25-50%", label: "25-50%" },
    { value: "greater than 50%", label: "50%+" },
  ],
};

export const FirmReprsntsOnChangeStdQtn = [
  "Firm_Represent_Purchaser_Lawyer_Express",
  "Firm_Represent_Mortgagor_Lawyer_Express",
  "Firm_Represent_Owner_Lawyer_Express",
  "Firm_Represent_Purchaser_Lawyer_QCBC_Express",
  "Firm_Represent_Mortgagor_Lawyer_QCBC_Express",
  "Firm_Represent_Owner_Lawyer_QCBC_Express",
  "FirmRepresentOwnerExpress",
  "FirmRepresentMortgagorExpress",
  "FirmRepresentPurchaserLawyerExpress",
  "FirmRepresentOwnerQCBCExpress",
  "FirmRepresentMortgagorQCBCExpress",
  "FirmRepresentPurchaserLawyerQCBCExpress",
];

export const LenderFirmReprsntsOnChangeStdQtn = [
  "Lenders_Lawyer_Express",
  "Lenders_LawyerQCBC_Express",
  "LenderLawyerExpress",
  "LendersLawyerQCBCExpress",
];

export const EligibleProgramCodeForNotChangingTypeOfMortgage = ["lddrefi", "alpine"]


export const EligibleProgramCodeForProvinceMatchValidation = [
  "nesto",
  "lddrefi",
  "marchand",
];

export const HideAddPurchaserForProgramcode = ["fnfhtc", "fnfptc"];
export const HideAddLenderForProgramcode = ["alpine"];

export const MultiFactorStandardQuestionName = [
  "MultiFactorIDV",
  "Multi_Factor_IDV",
  "Multi_Factor_IDV_Benficial_Owner",
];

export const HarbourMortgageStandardQuestionName = [
  "Order_TransactionProtection_Lender",
  "Super_Priority_Liens",
  "InsuredRequiresEnroachments",
  "InsuredRequiresEnroachments_V2_Express"
];

export const MaskedStandardQuestionName = [
  "EncompassHomeTransitNo",
  "EncompassHomeInstitutionNo",
  "EncompassHomeAccountNo"
];


export const OriginalTransferDateStandardQuestionName = [
  "OriginalTransferDate_EO_Express",
  "OriginalTransferDate_Express",
  "OriginalTransferExpress",
];

export const FintracDOBDOIStandardQuestionName = [
  "DateOfBirthExpress",
  "DateOfIssuanceExpress",
  "Date_Of_Birth_Express",
  "Date_Of_Issuance_Express",
];

export const SameDeedQuestionNames1 = [
  "Will_a_portion_of_the_proceeds_be_used_I_Acted",
  "MortgageActedBefore",
  "purchaserActedBefore",
  "MortgageActedBeforeExpressV2",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_V2_Express",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Purchaser_Express",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Mortgagor",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Mortgagor_Other",
  "PurchaserReferredby",
  "PurchaserReferredbyOther"
]; // I have acted for the purchaser(s) before on another real estate transaction.

export const SameDeedQuestionNames2 = [
  "VendorSolicitorExpress",
  "VendorSolicitorQCBCExpress",
  "Proceeds_to_vendor_Express",
  "Vendor_Solicitor_QCBC_Express",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Mortgagor_BrokerAlert",
  "Broker_Name_Express",
  "Broker_Phone_Express",
  "RealestateAlert",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Mortgagor_Broker_Name_Express",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Mortgagor_Broker_Phone_Express",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Purchaser_Realestate_FirstName_Express",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Purchaser_Realestate_Lastname_Express",
  "Will_a_portion_of_the_proceeds_be_used_I_Acted_Purchaser_Realestate_Phone_Express",
  "Realestate_FirstName_Express",
  "Realestate_LastName_Express",
  "PurchaserReferredbyRealestateFirstName",
  "PurchaserReferredbyRealestateLastName",
  "PurchaserReferredbyRealestatePhone",
  "PurchaserReferredbyBrokerFirstName",
  "PurchaserReferredbyBrokerPhone"
]; //Proceeds will be directed ONLY to the vendor/their solicitor; existing mortgagee; vendor�s unsecured debtors; disbursements directly related to the transaction. I will notify the Company of any re-direction of funds.

export const SameDeedQuestionNames3 = [
  "PriorMortgageUnsecuredPurchaseExpress",
  "PriorMortgageUnsecuredPrivateExpress",
  "PriorMortgageUnsecuredStandardExpress",
  "PriorMortgage_Net_Proceeds_Express",
  "PriorMortgage_Net_Proceeds_Purchase_Express",

]; // After paying prior mortgages and unsecured debts, what is the net proceed going to the vendor.

export const SameDeedQuestionNames4 = [
  "OrderTransactionProtectionOwner",
  "Order_TransactionProtection_Owner",
]; // Transaction Protection Endorsement is required for the owner

export const SAME_DEED_GROUPS = {
  SameDeedQuestionNames1,
  SameDeedQuestionNames2,
  SameDeedQuestionNames3,
  SameDeedQuestionNames4,
};

export const SAME_DEED_RULES = {
  SameDeedQuestionNames1: {
    behavior: "COPY_AND_LOCK"
  },
  SameDeedQuestionNames2: {
    behavior: "COPY_DEFAULT_EDITABLE"
  },
  SameDeedQuestionNames3: {
    behavior: "COPY_DEFAULT_EDITABLE"
  },
  SameDeedQuestionNames4: {
    behavior: "ONLY_PROPERTY_1"
  }
};

export const MultiSetQuestionStandarQuestionNameForButtonText = [
  "ToTheExtentUtilitiesFormALien",
  "Will_real_estate_taxes_be_paid",
];

export const RealEstateQuestionsStandardNamesResidential = [
  "ToTheExtentUtilitiesFormALienText",
  "Provide_assessment_RollNumber_Express",
  "ToTheExtentUtilitiesFormALienText_QC",
  "Tax_Certificate_Required_NL",
  "Tax_Certificate_Required_AB_MB",
  "Tax_Certificate_Required_NB",
  "Tax_Certificate_Required_NS",
  "Tax_Certificate_Required_PE",
  "Tax_Certificate_Required_QC",
  "ToTheExtentUtilitiesFormALienText_AB_MB",
  "ToTheExtentUtilitiesFormALienText_NB",
  "ToTheExtentUtilitiesFormALienText_NS",
  "ToTheExtentUtilitiesFormALienText_PE",
  "ToTheExtentUtilitiesFormALienText_NL",
];

export const TransactionTypeConstants = {
  TypeOfTransactionOptions: [
    { value: "1", label: "purchase" },
    { value: "2", label: "sharepurchase" },
    { value: "3", label: "refinance" },
    { value: "4", label: "existingownerpolicy" },
    { value: "5", label: "refinanceexistingownerpolicy" },
    { value: "6", label: "other" },
  ],
};
export const PendingOrderProgressBarVisibleConstansts = [
  "Waiting for Information",
  "Needs Approval",
  "Review Complete",
  "Final Review",
  "Under Review",
];
export const OrderStatusConstants = {
  DealTypeOptions: [
    { value: "ID Verification", label: "ID Verification" },
    { value: "Commercial", label: "Commercial" },
    { value: "Residential", label: "Residential" },
    { value: "Tax Verification", label: "Tax Verification" },
  ],
  DealTypeNumericOptions: [
    { value: "3", label: "ID Verification" },
    { value: "1", label: "Commercial" },
    { value: "4", label: "Residential" },
    { value: "6", label: "Tax Verification" },
  ],
  StatusOptions: [
    { value: "Not Yet Submitted", label: "Not Yet Submitted" },
    { value: "Submitted for Review", label: "Submitted for Review" },
    {
      value: "Waiting for additional info/doc(s)",
      label: "Waiting for additional info/doc(s)",
    },
    { value: "Credit Card", label: "Credit Card" },
    { value: "EFT", label: "EFT" },
    { value: "Cheque", label: "Cheque" },

    { value: "Needs Approval", label: "Needs Approval" },
    { value: "Under Review", label: "Underwriting Review" },
    { value: "Review Complete", label: "Review Complete" },
    { value: "CTIC ready for pickup", label: "CTIC ready for pickup" },
    { value: "Ready for pickup", label: "Ready for pickup" },
    { value: "Picked Up", label: "Picked Up" },
    { value: "Cancelled", label: "Cancelled Pending" },
    { value: "Cancelled", label: "Cancelled" },
  ],
};

// "commercialOption":"Commercial",
//     "residentialOption":"Residential",
//     "TaxVerifOption":"Tax Verification",
//     "CancellationPendingOption":"Cancellation Pending",
//     "CancelledOption":"Cancelled",
//     "FinalReviewOption":"Final Review",
//     "NeedsApprovalOption":"Needs Approval",
//     "NotYetSubmittedOption":"Not Yet Submitted",
//     "ReadyForPickupOption":"Ready for Pickup",
//     "UnderReviewOption":"Under Review",
//     "WaitingForInfoOption":"Waiting For Information",
export const OrderStatusConstant = (type) => {
  const { t } = useTranslation();
  const OrderStatusConstants = {
    DealTypeOptions: [
      {
        value: "ID Verification",
        ansvalue: "ID Verification",
        label: "IDVerificationOption",
      },
      {
        value: "Commercial",
        ansvalue: "Commercial",
        label: "commercialOption",
      },
      {
        value: "Residential",
        ansvalue: "Residential",
        label: "residentialOption",
      },
      {
        value: "Tax Verification",
        ansvalue: "Tax Verification",
        label: "TaxVerifOption",
      },
    ],
    DealTypeNumericOptions: [
      { value: "4", label: "IDVerificationOption" },
      { value: "2", label: "commercialOption" },
      { value: "1", label: "residentialOption" },
      { value: "6", label: "TaxVerifOption" },
    ],
    StatusOptions: [
      {
        value: "Cancellation Pending",
        label: "CancellationPendingOption",
        imageurl: ` <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197315)'
                    stroke='#E2211C'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='m12.5 7.5-5 5M7.5 7.5l5 5M18.334 9.232v.766a8.334 8.334 0 1 1-4.942-7.616' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197315'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>`,
      },
      {
        value: "Cancelled",
        label: "CancelledOption",
        imageurl: ` <svg width='20' height='20' fill='none'>
                  <path
                    d='M15 5 5 15M5 5l10 10'
                    stroke='#E2211C'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>`,
      },
      {
        value: "Final Review",
        label: "FinalReviewOption",
        imageurl: `  <svg width='20' height='20' fill='none'>
                  <path
                    d='M13.333 3.332H15a1.667 1.667 0 0 1 1.666 1.667v11.666A1.667 1.667 0 0 1 15 18.332H5a1.667 1.667 0 0 1-1.667-1.667V5A1.667 1.667 0 0 1 5 3.332h1.666'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M12.5 1.668h-5a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h5c.46 0 .834-.373.834-.833V2.501a.833.833 0 0 0-.834-.833Z'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>`,
      },
      {
        value: "Needs Approval",
        label: "NeedsApprovalOption",
        imageurl: `<svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197272)'
                    stroke='#595959'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path
                      d='M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z'
                      strokeWidth='1.5'
                    />
                    <path
                      d='M10 6.668v3.333M10 13.332h.009'
                      strokeWidth='2'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197272'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>`,
      },
      {
        value: "Not Yet Submitted",
        label: "NotYetSubmittedOption",
        imageurl: ` <svg width='20' height='20' fill='none'>
                  <path
                    d='M4.167 10h11.667'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>`,
      },
      {
        value: "Ready for Pickup",
        label: "ReadyForPickupOption",
        imageurl: `  <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197294)'
                    stroke='#09B505'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M18.334 9.232v.766a8.334 8.334 0 1 1-4.942-7.616' />
                    <path d='M18.333 3.332 10 11.674l-2.5-2.5' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197294'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>`,
      },
      {
        value: "Under Review",
        label: "UnderReviewOption",
        imageurl: `  <svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197280)'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M9.167 3.332H3.334a1.667 1.667 0 0 0-1.667 1.667v11.666a1.667 1.667 0 0 0 1.667 1.667H15a1.667 1.667 0 0 0 1.667-1.667v-5.833' />
                    <path d='M15.417 2.084a1.768 1.768 0 0 1 2.5 2.5L10 12.501l-3.333.833.833-3.333 7.917-7.917Z' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197280'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>`,
      },
      {
        value: "Waiting For Information",
        label: "WaitingForInfoOption",
        imageurl: `<svg width='20' height='20' fill='none'>
                  <g
                    clipPath='url(#clip0_4811_197264)'
                    stroke='#595959'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM8.333 12.5v-5M11.667 12.5v-5' />
                  </g>
                  <defs>
                    <clipPath id='clip0_4811_197264'>
                      <rect
                        width='20'
                        height='20'
                        fill='#fff'
                      />
                    </clipPath>
                  </defs>
                </svg>`,
      },
      {
        value: "Pending",
        label: "PendingOption",
        imageurl: `<svg width="20" height="20" fill="none">
            <g
              stroke="#595959"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="10" cy="10" r="8.333" />
              <path d="M10 5.833v4.167l2.5 2.5" />
            </g>
          </svg>`,
      },
    ],
  };
  switch (type) {
    case "DealType":
      return OrderStatusConstants.DealTypeOptions;
    case "DealTypeNumeric":
      return OrderStatusConstants.DealTypeNumericOptions;
    case "Status":
      return OrderStatusConstants.StatusOptions;
  }
};

export const AllPropertyTypes = (province) => {
  const { t } = useTranslation();
  const PropertyTypeAll = {
    TypesForAll: [
      { value: "Bare / Vacant Condominium", label: t("Option1") },
      { value: "Bed and Breakfast", label: t("Option2") },
      { value: "Condominium / Strata (new or resale)", label: t("Option4") },
      { value: "Farm with Single Family Dwelling", label: t("Option5") },
      { value: "Live-Work Unit", label: t("Option7") },
      {
        value: "Mobile Home",
        label: t("Option8"),
      },
      { value: "Multi-Unit Residence", label: t("Option9") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("Option10"),
      },
      { value: "Partial Interest / Undivided Interest", label: t("Option11") },
      { value: " Rooming / Student House", label: t("Option12") },
      { value: "Single Family Dwelling", label: t("Option13") },
      { value: "Vacant Land", label: t("Option15") },
      { value: "Other", label: t("Option16") },
    ],
    TypesForBC: [
      { value: "Bare land strata", label: "Bare land strata" },
      { value: "Bed and Breakfast", label: t("Option2") },
      { value: "Condominium / Strata (new or resale)", label: t("Option4") },
      { value: "Farm with Single Family Dwelling", label: t("Option5") },
      { value: "Live-Work Unit", label: t("Option7") },
      {
        value: "Mobile Home",
        label: t("Option8"),
      },
      { value: "Multi-Unit Residence", label: t("Option9") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("Option10"),
      },
      { value: "Partial Interest / Undivided Interest", label: t("Option11") },
      { value: " Rooming / Student House", label: t("Option12") },
      { value: "Single Family Dwelling", label: t("Option13") },
      { value: "Vacant Land", label: t("Option15") },
      { value: "Other", label: t("Option16") },
    ],
    TypesForQC: [
      { value: "Bed and Breakfast", label: t("Option2") },
      { value: "Condominium / Strata (new or resale)", label: t("Option4") },
      { value: "Farm with Single Family Dwelling", label: t("Option5") },
      { value: "Horizontal Co-Ownership", label: t("Option6") },
      { value: "Live-Work Unit", label: t("Option7") },
      {
        value: "Mobile Home",
        label: t("Option8"),
      },
      { value: "Multi-Unit Residence", label: t("Option9") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("Option10"),
      },
      { value: " Rooming / Student House", label: t("Option12") },
      { value: "Single Family Dwelling", label: t("Option13") },
      { value: "Undivided Co-Ownership", label: t("Option14") },
      { value: "Vacant Land", label: t("Option15") },
      { value: "Other", label: t("Option16") },
    ],
    TypesForONandNL: [
      { value: "Bare / Vacant Condominium", label: t("Option1") },
      { value: "Bed and Breakfast", label: t("Option2") },
      {
        value: "Common element Condominium",
        label: t("Option3"),
      },
      { value: "Condominium / Strata (new or resale)", label: t("Option4") },
      { value: "Farm with Single Family Dwelling", label: t("Option5") },
      { value: "Live-Work Unit", label: t("Option7") },
      {
        value: "Mobile Home",
        label: t("Option8"),
      },
      { value: "Multi-Unit Residence", label: t("Option9") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("Option10"),
      },
      { value: "Partial Interest / Undivided Interest", label: t("Option11") },
      { value: " Rooming / Student House", label: t("Option12") },
      { value: "Single Family Dwelling", label: t("Option13") },
      { value: "Vacant Land", label: t("Option15") },
      { value: "Other", label: t("Option16") },
    ],
  };
  return province === "BC"
    ? PropertyTypeAll.TypesForBC
    : province === "QC"
      ? PropertyTypeAll.TypesForQC
      : province === "ON" || province === "NL"
        ? PropertyTypeAll.TypesForONandNL
        : PropertyTypeAll.TypesForAll;
};

export const AllQuotePropertyTypes = (province) => {
  const { t } = useTranslation();
  const PropertyTypeAll = {
    TypesForAll: [
      { value: "Apartment building", label: t("PropOption1") },
      { value: "Commercial / Industrial / Office building", label: t("PropOption2") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Energy project", label: t("PropOption4") },
      { value: "Farm, over 2 acres & incoming generating", label: t("PropOption5") },
      { value: " Hotel / Motel", label: t("PropOption6") },
      { value: "Mixed Use (Residential & Commercial)", label: t("PropOption7") },
      { value: "Land under development", label: t("PropOption8") },
      { value: "Partial Interest / Undivided Interest", label: t("PropOption9") },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Vacant land", label: t("PropOption12") },
      { value: "Other", label: t("PropOption13") },
    ],
    TypesForQC: [
      { value: "Apartment building", label: t("PropOption1") },
      { value: "Commercial / Industrial / Office building", label: t("PropOption2") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Energy project", label: t("PropOption4") },
      { value: "Farm, over 2 acres & incoming generating", label: t("PropOption5") },
      { value: " Hotel / Motel", label: t("PropOption6") },
      { value: "Mixed Use (Residential & Commercial)", label: t("PropOption7") },
      { value: "Land under development", label: t("PropOption8") },
      { value: "Partial Interest / Undivided Interest", label: t("PropOption9") },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Undivided Co-Ownership", label: t("PropOption11") },
      { value: "Vacant land", label: t("PropOption12") },
      { value: "Other", label: t("PropOption13") },
    ],
  };

  return province === "QC"
    ? PropertyTypeAll.TypesForQC
    : PropertyTypeAll.TypesForAll;
};

export const AllResidentialQuotePropertyTypes = (province) => {
  const { t } = useTranslation();

  const propertyTypes = {
    TypesForAll: [
      { value: "Bed and Breakfast", label: t("PropOption14") },
      { value: "Bare / Vacant Land Condominium", label: t("PropOption15") },
      { value: "Common Element Condominium", label: t("PropOption17") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Farm with Single Family Dwelling", label: t("PropOption18") },
      { value: "Live-Work Unit", label: t("PropOption20") },
      { value: "Mobile Home", label: t("PropOption21") },
      { value: "Multi Unit Residence", label: t("PropOption22") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("PropOption23"),
      },
      {
        value: "Partial Interest / Undivided Interest",
        label: t("PropOption9"),
      },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Single Family Dwelling", label: t("PropOption24") },
      { value: "Vacant land", label: t("PropOption12") },
    ],

    TypesForBC: [
      { value: "Bed and Breakfast", label: t("PropOption14") },
      { value: "Bare / Vacant Land Condominium", label: t("PropOption15") },
      { value: "Bare Land Strata", label: t("PropOption16") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Farm with Single Family Dwelling", label: t("PropOption18") },
      { value: "Live-Work Unit", label: t("PropOption20") },
      { value: "Mobile Home", label: t("PropOption21") },
      { value: "Multi Unit Residence", label: t("PropOption22") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("PropOption23"),
      },
      {
        value: "Partial Interest / Undivided Interest",
        label: t("PropOption9"),
      },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Single Family Dwelling", label: t("PropOption24") },
      { value: "Vacant land", label: t("PropOption12") },
    ],

    TypesForQC: [
      { value: "Bed and Breakfast", label: t("PropOption14") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Farm with Single Family Dwelling", label: t("PropOption18") },
      { value: "Horizontal Co-Ownership", label: t("PropOption19") },
      { value: "Live-Work Unit", label: t("PropOption20") },
      { value: "Mobile Home", label: t("PropOption21") },
      { value: "Multi Unit Residence", label: t("PropOption22") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("PropOption23"),
      },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Single Family Dwelling", label: t("PropOption24") },
      { value: "Undivided Co-Ownership", label: t("PropOption11") },
      { value: "Vacant land", label: t("PropOption12") },
    ],
  };

  if (province === "QC") return propertyTypes.TypesForQC;
  if (province === "BC") return propertyTypes.TypesForBC;
  return propertyTypes.TypesForAll;
};

export const AllResidentialInternalQuotePropertyTypes = (province) => {
  const { t } = useTranslation();

  const propertyTypes = {
    TypesForAll: [
      { value: "Bed and Breakfast", label: t("PropOption14") },
      { value: "Bare / Vacant Land Condominium", label: t("PropOption15") },
      { value: "Common Element Condominium", label: t("PropOption17") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Farm with Single Family Dwelling", label: t("PropOption18") },
      { value: "Live-Work Unit", label: t("PropOption20") },
      { value: "Mobile Home", label: t("PropOption21") },
      { value: "Multi Unit Residence", label: t("PropOption22") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("PropOption23"),
      },
      {
        value: "Partial Interest / Undivided Interest",
        label: t("PropOption9"),
      },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Single Family Dwelling", label: t("PropOption24") },
      { value: "Vacant land", label: t("PropOption12") },
      { value: "Other", label: t("PropOption13") },
    ],

    TypesForBC: [
      { value: "Bed and Breakfast", label: t("PropOption14") },
      { value: "Bare / Vacant Land Condominium", label: t("PropOption15") },
      { value: "Bare Land Strata", label: t("PropOption16") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Farm with Single Family Dwelling", label: t("PropOption18") },
      { value: "Live-Work Unit", label: t("PropOption20") },
      { value: "Mobile Home", label: t("PropOption21") },
      { value: "Multi Unit Residence", label: t("PropOption22") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("PropOption23"),
      },
      {
        value: "Partial Interest / Undivided Interest",
        label: t("PropOption9"),
      },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Single Family Dwelling", label: t("PropOption24") },
      { value: "Vacant land", label: t("PropOption12") },
      { value: "Other", label: t("PropOption13") },
    ],

    TypesForQC: [
      { value: "Bed and Breakfast", label: t("PropOption14") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Farm with Single Family Dwelling", label: t("PropOption18") },
      { value: "Horizontal Co-Ownership", label: t("PropOption19") },
      { value: "Live-Work Unit", label: t("PropOption20") },
      { value: "Mobile Home", label: t("PropOption21") },
      { value: "Multi Unit Residence", label: t("PropOption22") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("PropOption23"),
      },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Single Family Dwelling", label: t("PropOption24") },
      { value: "Undivided Co-Ownership", label: t("PropOption11") },
      { value: "Vacant land", label: t("PropOption12") },
      { value: "Other", label: t("PropOption13") },
    ],

    // Yukon special case: no Common Element Condominium
    TypesForYK: [
      { value: "Bed and Breakfast", label: t("PropOption14") },
      { value: "Bare / Vacant Land Condominium", label: t("PropOption15") },
      { value: "Condominium/Strata", label: t("PropOption3") },
      { value: "Farm with Single Family Dwelling", label: t("PropOption18") },
      { value: "Live-Work Unit", label: t("PropOption20") },
      { value: "Mobile Home", label: t("PropOption21") },
      { value: "Multi Unit Residence", label: t("PropOption22") },
      {
        value: "New Single Family Dwelling from a Builder",
        label: t("PropOption23"),
      },
      {
        value: "Partial Interest / Undivided Interest",
        label: t("PropOption9"),
      },
      { value: " Rooming / Student House", label: t("PropOption10") },
      { value: "Single Family Dwelling", label: t("PropOption24") },
      { value: "Vacant land", label: t("PropOption12") },
      { value: "Other", label: t("PropOption13") },
    ],
  };

  if (province === "QC") return propertyTypes.TypesForQC;
  if (province === "BC") return propertyTypes.TypesForBC;
  if (province === "YK") return propertyTypes.TypesForYK;

  return propertyTypes.TypesForAll;
};

export const QuoteEndorsementsOptions = () => {
  const { t } = useTranslation();
  const EndorsementOptions = {
    options: [
      { value: t("QuoteOtherEndorsement"), label: t("QuoteOtherEndorsement") },
    ],
  };
  return EndorsementOptions.options;
};

export const QuoteConstant = {
  PropertyType: [
    { value: "Bare / Vacant Condominium", label: "Bare / Vacant Condominium" },
    {
      value: "Condominium / Strata (new or resale)",
      label: "Condominium / Strata (new or resale)",
    },
    { value: "Farm", label: "Farm" },
    { value: "Live-Work Unit", label: "Live-Work Unit" },
    { value: "Mobile Home", label: "Mobile Home" },
    { value: "Multi Unit Residence", label: "Multi Unit Residence" },
    {
      value: "New Single Family Dwelling from a Builder",
      label: "New Single Family Dwelling from a Builder",
    },
    { value: " Rooming / Student House", label: "Rooming / Student House" },
    { value: "Single Family Dwelling", label: "Single Family Dwelling" },
    { value: "Vacant Land", label: "Vacant Land" },
    { value: "Other", label: "Other" },
  ],
  PropertyLocatedIn: [
    { value: "ON", label: "ON" },
    { value: "AB", label: "AB" },
    { value: "BC", label: "BC" },
    { value: "MB", label: "MB" },
    { value: "SK", label: "SK" },
    { value: "QC", label: "QC" },
    { value: "NL", label: "NL" },
    { value: "PE", label: "PE" },
    { value: "NS", label: "NS" },
    { value: "NT", label: "NT" },
    { value: "NU", label: "NU" },
    { value: "NB", label: "NB" },
    { value: "YT", label: "YT" },
  ],
  TypeOfMortgage: [
    { value: "1", label: "Standard Loan" },
    { value: "2", label: "Private Loan" },
    { value: "3", label: "Vendor Take Back Mortgage" },
  ],
  DealTypeOptions: [
    { value: "Residential", label: "Residential" },
    { value: "Commercial", label: "Commercial" },
    { value: "All", label: "All" },
  ],
};

export const InvoiceConstants = {
  PaymentMethodOptions: [
    { value: "EFT", label: "EFT" },
    {
      value: "Credit Card - Self Administered",
      label: "Credit Card - Self Administered",
    },
    {
      value: "Credit Card - Payment On Closing",
      label: "Credit Card - Payment On Closing",
    },
    { value: "Credit Card - Weekly", label: "Credit Card - Weekly" },
    { value: "Credit Card - Bi-Weekly", label: "Credit Card - Bi-Weekly" },
    { value: "Credit Card - Monthly", label: "Credit Card - Monthly" },
    { value: "Cheque", label: "Cheque" },
    // { value: "All", label: "All" },
  ],
  PastPaymentMethodOptions: [
    { value: "Cheque", label: "Cheque" },
    { value: "Credit Card", label: "Credit Card" },
    { value: "EFT", label: "EFT" },

    // { value: "All", label: "All" },
  ],
};

export const SalutationConstants = {
  salutations: [
    { value: undefined, label: "litSelect" },
    { value: "Mr.", label: "litMr" },
    { value: "Mrs.", label: "litMrs" },
    { value: "Ms.", label: "litMs" },
    { value: "Miss", label: "litMiss" },
    { value: "Mx.", label: "litMx" },
  ],
};

export const CancelOrderReasonOptions = {
  CancelReason: [
    { value: "Deal fell through", label: "Deal_fell_through" },
    { value: "Duplicate order", label: "Duplicate_order" },
    {
      value: "Lender does not accept CTIC",
      label: "Lender_does_not_accept_CTIC",
    },
    { value: "Other", label: "Other" },
  ],
};

export const GetOptionsWithToolTip = ({ text, tooltip }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="item  flex flex-row"
        data-tooltip-id="my-tooltip"
        title={t(tooltip)}
      >
        {t(text)}
        <img
          src="/images/tooltip-icon.svg"
          id="tooltip-existing-client"
          alt="tooltip"
          style={{ marginLeft: "auto", height: 20 }}
          className=" relative clientToolTip"
        />
      </div>
    </>
  );
};

export const BillingType = {
  PrefferredBillingType: [
    {
      value: "1",
      label: (
        <GetOptionsWithToolTip
          text="Payment On Closing"
          tooltip="paymentProcessingTooltip"
        />
      ),

      option: "Payment On Closing",
    },
    {
      value: "2",
      label: (
        <GetOptionsWithToolTip
          text="On Account (CTIC-Administered)"
          tooltip="paymentTooltip1"
        />
      ),
      option: "On Account (CTIC-Administered)",
    },
    {
      value: "3",
      label: (
        <GetOptionsWithToolTip
          text="On Account (Self-Administered)"
          tooltip="paymentTooltip2"
        />
      ),
      option: "On Account (Self-Administered)",
    },
  ],
  Frequency: [
    {
      value: "1",
      label: <GetOptionsWithToolTip text="weekly" tooltip="paymentTooltip3" />,
    },
    {
      value: "2",
      label: (
        <GetOptionsWithToolTip text="biWeekly" tooltip="paymentTooltip4" />
      ),
    },
    {
      value: "3",
      label: <GetOptionsWithToolTip text="monthly" tooltip="paymentTooltip5" />,
    },
  ],
};

export const UploadDocumentTypesArrayConstansts = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/rtf",
  "image/jpeg",
  "image/gif",
  "image/bmp",
  //"application/x-mfg",
];

export const UploadDocumentAcceptedTypesStringConstants =
  ".pdf,.docx,.doc,.rtf,.jpeg,.jpg,.gif,.bmp,";//.mfg

export const UploadDocumentTypesMIMEMap = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  doc: "application/msword",
  rtf: "application/rtf",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  gif: "image/gif",
  bmp: "image/bmp",
  // mfg: "application/x-mfg",
};

export const downloadableFileTypes = [
  "docx",
  "doc",
  "rtf",
  "jpeg",
  "jpg",
  "gif",
  "bmp",
  //"mfg",
];

export const provincesWithTranslation = [
  { abbr: 'AB', en: 'Alberta', fr: 'Alberta' },
  { abbr: 'BC', en: 'British Columbia', fr: 'Colombie-Britannique' },
  { abbr: 'MB', en: 'Manitoba', fr: 'Manitoba' },
  { abbr: 'NB', en: 'New Brunswick', fr: 'Nouveau-Brunswick' },
  { abbr: 'NL', en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador' },
  { abbr: 'NS', en: 'Nova Scotia', fr: 'Nouvelle-Écosse' },
  { abbr: 'NT', en: 'Northwest Territories', fr: 'Territoires du Nord-Ouest' },
  { abbr: 'NU', en: 'Nunavut', fr: 'Nunavut' },
  { abbr: 'ON', en: 'Ontario', fr: 'Ontario' },
  { abbr: 'PE', en: 'Prince Edward Island', fr: 'l’île du Prince-Édouard' },
  { abbr: 'QC', en: 'Quebec', fr: 'Québec' },
  { abbr: 'SK', en: 'Saskatchewan', fr: 'Saskatchewan' },
  { abbr: 'YT', en: 'Yukon', fr: 'Yukon' }
];

export const QUOTE_DISABLED_FIELDS = [
  'thisTransIsPurchase',
  'ownersPolicyReq',
  'existingOwnersPolicyReq',
  'loanPolicy',
  'Lender',
  'MortgagePriority',
  'mortgageAmount',
];

const constants = Object.freeze({
  Roles,
  PasswordRegex,
  RegistrationRegex,
  TextBoxErrorMsgCss,
  RegistrationPageConstants,
  TransactionTypeConstants,
  EmailRegex,
  SalutationConstants,
  QuoteConstant,
  TransactionTypeConstants,
  OrderStatusConstant,
  PendingOrderProgressBarVisibleConstansts,
  QuoteEndorsementsOptions,
});
export default constants;
